module.exports = __webpack_public_path__ + "static/media/icons8-ok.13ca1dde.svg";